import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import Footer from "../../components/footer/Footer";
import IconCard1 from "../../images/icon_card_13.png";
import IconCard2 from "../../images/icon_card_12.png";
import IconCard3 from "../../images/icon_card_11.png";
import IconCard4 from "../../images/icon_card_10.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS3 = () => {
  const solutions = [
    {
      title: "Struggling to Stand Out in the Competitive Fashion Market?",
      problem:
        "High competition, low brand visibility, and difficulty in reaching the right audience.",
      solution:
        "We implement Search engine optimized fashion websites, influencer collaborations, and targeted ad campaigns to amplify your brand reach.",
    },
    {
      title: "Low Conversion Rates & Abandoned Carts?",
      problem:
        "Poor UX/UI design, complicated checkout processes, and lack of customer retention strategies.",
      solution:
        "We design user friendly, high converting e-commerce platforms with seamless navigation, personalized recommendations, & abandoned cart recovery systems.",
    },
    {
      title: "Ineffective Social Media & Engagement?",
      problem:
        "The Problem: Lack of social media strategy, inconsistent branding, and low engagement.",
      solution:
        "We offer social media marketing & management, influencer partnerships, and viral content creation to boost engagement and brand awareness & loyalty.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "E-commerce website design with stunning visuals",
        "Mobile-friendly online stores with seamless checkout",
        "AI-powered product recommendations & personalization",
        "Inventory management & integration with third-party platforms",
        "Virtual try-on & augmented reality (AR) shopping experiences",
      ],
      image: require("../../images/web-development-2.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "Fashion SEO & blog content marketing for organic traffic growth",
        "PPC & social media ad campaigns for product launches & promotions",
        "Influencer marketing & brand collaborations for viral reach",
        "Email marketing & campaigns for customer retention",
        "Social media trend-driven content creation",
      ],
      image: require("../../images/digital-marketing-2.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    {
      title: "E-commerce UI Mockups & Trend-Based Designs",
      icon: IconCard1,
    },
    {
      title: "Social Media Analytics & Campaign Performance",
      icon: IconCard2,
    },
    {
      title: "Fashion SEO & Online Store Conversion Insights",
      icon: IconCard3,
    },
    {
      title: "Brand Identity & Visual Aesthetic Strategies",
      icon: IconCard4,
    },
  ];

  const caseStudyData = {
    sectionTitle: "Real Results for Fashion Brands",
    sectionSubtitle:
      "Our revamped e-commerce store saw a 50% increase in sales within 3 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Elevate Your Fashion Business",
    description:
      "Turn your brand into a fashion powerhouse with innovative digital solutions. Let's create something extraordinary together!",
    buttonText: "Schedule a Strategy Call Today",
    image: require("../../images/fashion.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay ahead of the latest trends in IT innovation, security, and digital transformation.";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={
            "Elevate Your Fashion Brand with Cutting-Edge Digital Strategies"
          }
          pageSub={
            "From stunning e-commerce websites to trend-driven digital marketing, we help fashion brands captivate audiences, increase sales, and build a powerful online presence."
          }
          backgroundImage={require("../../images/web-4.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Bringing Innovation to Fashion"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="flex-end"
          justifyContent="flex-start"
          textAlign="left"
          boxAlign="flex-start"
          titleColor="#fff"
          descriptionColor="#fff"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS3;
